import { isGroup } from '../../option/utils/filter-options';
/**
 * One option at a time. Choosing the selected option again keeps it selected.
 * Only the first entry of `selectedOptions` is used. Group headers are never selectable.
 */
export function singleSelection(selectedOptions) {
    var _a;
    const selected = selectedOptions.slice(0, 1);
    const selectedValue = (_a = selected[0]) === null || _a === void 0 ? void 0 : _a.value;
    return {
        selectionType: 'single',
        interactiveGroups: false,
        selectedOptions: selected,
        getGroupState: (option) => {
            if (!isGroup(option.option)) {
                return { selected: false, indeterminate: false };
            }
            const children = option.option.options;
            // Match the pre-refactor Select behaviour: a child with a falsy value is never counted, even when the
            // selected value is also falsy (baseline `use-select.ts` built `__selectedValuesSet` from `!!item.value`).
            const totalSelected = selectedValue === undefined
                ? 0
                : children.filter(child => !!child.value && child.value === selectedValue).length;
            return { selected: false, indeterminate: totalSelected > 0 && totalSelected !== children.length };
        },
        getNextSelection: (option) => [option.option],
    };
}
//# sourceMappingURL=single-selection.js.map